export default __webpack_public_path__ + "static/oreo-logo-7ba7a733d68505ab35a303c628e308ec.png";